import {
  POST_SEND_EXECUTIVE_LIST_REQUEST,
  POST_SEND_EXECUTIVE_LIST_SUCCESS,
  POST_SEND_EXECUTIVE_LIST_FAILURE,
  GET_EXECUTIVE_LIST_REQUEST,
  GET_EXECUTIVE_LIST_SUCCESS,
  GET_EXECUTIVE_LIST_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_FAILURE,
  POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_REQUEST,
  POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_SUCCESS,
  POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_AI_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_AI_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_AI_FAILURE,
  GET_EXECUTIVE_LIST_FILTERS_REQUEST,
  GET_EXECUTIVE_LIST_FILTERS_SUCCESS,
  GET_EXECUTIVE_LIST_FILTERS_FAILURE,
  POST_EXECUTIVE_LIST_FILTERS_REQUEST,
  POST_EXECUTIVE_LIST_FILTERS_SUCCESS,
  POST_EXECUTIVE_LIST_FILTERS_FAILURE,
  PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST,
  PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS,
  PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE,
  DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST,
  DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS,
  DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE,
  SET_SHOW_EXEC_LIST_INFO_BOX,
  SET_SHOW_EXEC_LIST_BANNER,
  GET_EXPORTED_LIST_REQUEST,
  GET_EXPORTED_LIST_SUCCESS,
  GET_EXPORTED_LIST_FAILURE,
  POST_EXECUTIVE_LIST_CSV_REQUEST,
  POST_EXECUTIVE_LIST_CSV_SUCCESS,
  POST_EXECUTIVE_LIST_CSV_FAILURE,
  GET_EXECUTIVE_LIST_UPDATE_REQUEST,
  GET_EXECUTIVE_LIST_UPDATE_SUCCESS,
  GET_EXECUTIVE_LIST_UPDATE_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_GETTAGS_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_GETTAGS_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_GETTAGS_FAILURE,
  CLEAR_EXECUTIVE_LIST,
  POST_USERS_PAYMENTS_AND_PLANS_SUCCESS,
  POST_USERS_ME_PLANS_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_REQUEST,
  POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_SUCCESS,
  POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_FAILURE,
  POST_EXECUTIVE_LIST_SALESFORCE_SYNC_REQUEST,
  POST_EXECUTIVE_LIST_SALESFORCE_SYNC_SUCCESS,
  POST_EXECUTIVE_LIST_SALESFORCE_SYNC_FAILURE,
  POST_IP_CHECK_REQUEST,
  POST_IP_CHECK_SUCCESS,
  POST_IP_CHECK_FAILURE,
  LOG_OUT_SUCCESS,
  CLEAR_ATTACK_LIST_STATE,
  POST_ATTACK_LIST_ANALYZE_URL_REQUEST,
  POST_ATTACK_LIST_ANALYZE_URL_SUCCESS,
  POST_ATTACK_LIST_ANALYZE_URL_FAILURE,
  POST_ATTACK_LIST_EXECUTE_TAGGING_REQUEST,
  POST_ATTACK_LIST_EXECUTE_TAGGING_SUCCESS,
  POST_ATTACK_LIST_EXECUTE_TAGGING_FAILURE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import * as messages from '../../constants/Messages';
import { formatErrorMessage } from '../../utils/utils'

const { OrderedMap, Map } = require('immutable')

const initialState = {
  executiveList: OrderedMap({}),
  exportedList: Map(),
  pageInfo: null,
  isLoading: false,
  overwrite: false,
  showPostoExecListDialog: false,
  isLoadingFilter: false,
  filters: OrderedMap({}),
  isPostingFilter: false,
  deletingFilterId: null,
  patchingFilterId: null,
  errorMessage: '',
  message: '',
  shortMessage: '',
  showInfoBox: true,
  showBanner: true,
  corporationCount: 0,
  isLoadingCsv: false,
  addedKeyman: [],
  delKeyman: [],
  existsDepartmentTelKeyman: [],
  addedKeymanTotalCount: 0,
  delKeymanTotalCount: 0,
  existsDepartmentTelKeymanTotalCount: 0,
  recommendKeyman: [],
  recommendKeymanTotalCount: 0,
  isLoadingUpdatedKeyman: false,
  requestPage: 1,
  tags: [],
  selectedAddressTags: [],
  isLoadingSidebar: 0,
  isLoadingSelectedAddressTags: false,
  isLoadingCheck: false,
  isDeletingTags: false,
  isUpdatingTags: false,
  isPostingSalesforceSync: false,
  isLoadingAiSearch: false,
  aiSearchResponse: null,
  hasLetterOrderHistoryNames: [],
  duplicateNames: [],
  selectExecutivePerson: null,
  executiveListAdvancedSearchIpCheck: false,
  executiveListAdvancedSearchIpCheckLoading: false,
  // attack list
  isLoadingAttackList: false,
  attackListTag: null,
  attackListExtractedConditions: null,
  attackListSummary: null,
  attackListTaggedCount: null,
  attackListError: null,
  // 2段階API
  isAnalyzingUrl: false,
  isExecutingTagging: false,
  attackListAnalysisId: null,
}

export default (state = initialState, action) => {
  state = {
    ...state,
    message: '',
    errorMessage: '',
    shortMessage: ''
  }

  let list, tags = [], hasLetterOrderHistoryNames = [], duplicateNames = [];

  switch (action.type) {
    case POST_EXECUTIVE_LIST_SEARCH_REQUEST:
    case GET_EXECUTIVE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        overwrite: action.payload.overwrite,
        requestPage: action.payload.page,
      };
    case POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_REQUEST:
      return {
        ...state,
        isLoadingCsv: true,
      };
    case POST_EXECUTIVE_LIST_SEARCH_SUCCESS:
    case GET_EXECUTIVE_LIST_SUCCESS:
      if (action.payload.pageInfo && action.payload.pageInfo.current_page === state.requestPage) {

        list = action.payload.overwrite ? OrderedMap({}) : state.executiveList;
        action.payload.list.forEach(item => {
          list = list.set(item.id, item);
        })

        return {
          ...state,
          isLoading: false,
          executiveList: list,
          pageInfo: action.payload.pageInfo,
          overwrite: false,
          corporationCount: isNaN(action.payload.corporationCount) ? state.corporationCount : action.payload.corporationCount,
        };
      } else {
        return state;
      }
    case POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_SUCCESS:
      return {
        ...state,
        isLoadingCsv: false,
      };
    case POST_EXECUTIVE_LIST_SEARCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload.error.message ? action.payload.error.message : errMessages.ERR_GET_FAILURE,
        overwrite: false,
      };
    case POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_FAILURE:
      return {
        ...state,
        isLoadingCsv: false,
        errorMessage: action.payload.error.message ? action.payload.error.message : errMessages.ERR_GET_FAILURE,
      };
    case POST_EXECUTIVE_LIST_SEARCH_AI_REQUEST:
      return {
        ...state,
        isLoadingAiSearch: true,
        errorMessage: '',
      };
    case POST_EXECUTIVE_LIST_SEARCH_AI_SUCCESS:
      return {
        ...state,
        isLoadingAiSearch: false,
        aiSearchResponse: action.payload.response,
        // AI検索は通常のPOST成功メッセージを表示しない
      };
    case POST_EXECUTIVE_LIST_SEARCH_AI_FAILURE:
      return {
        ...state,
        isLoadingAiSearch: false,
        errorMessage: action.payload.error.message ? action.payload.error.message : errMessages.ERR_GET_FAILURE,
      };
    case GET_EXECUTIVE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
        overwrite: false,
      };
    case GET_EXECUTIVE_LIST_FILTERS_REQUEST:
      return {
        ...state,
        isLoadingFilter: true,
      }
    case GET_EXECUTIVE_LIST_FILTERS_SUCCESS: {
      let filters = state.filters;
      action.payload.filters.forEach(filter => {
        filters = filters.set(filter.id, filter);
      });
      return {
        ...state,
        isLoadingFilter: false,
        filters: filters,
      }
    }
    case GET_EXECUTIVE_LIST_FILTERS_FAILURE:
      return {
        ...state,
        isLoadingFilter: false,
      }
    case POST_SEND_EXECUTIVE_LIST_REQUEST:
      return {
        ...state,
        isLoadingCheck: true,
      }
    case POST_SEND_EXECUTIVE_LIST_SUCCESS:
      hasLetterOrderHistoryNames = Array.from(action.payload.hasLetterOrderHistoryNames);
      duplicateNames = Array.from(action.payload.duplicateNames);

      return {
        ...state,
        isLoadingCheck: false,
        hasLetterOrderHistoryNames: hasLetterOrderHistoryNames,
        duplicateNames: duplicateNames,
        selectExecutivePerson: action.payload.selectExecutivePerson,
      }
    case POST_SEND_EXECUTIVE_LIST_FAILURE:
      return {
        ...state,
        isLoadingCheck: false,
        errorMessage: action.payload.error.data.message ? action.payload.error.data.message : errMessages.ERR_ORDER_FAILURE
      }
    case POST_EXECUTIVE_LIST_FILTERS_REQUEST:
      return {
        ...state,
        isPostingFilter: true,
      }
    case POST_EXECUTIVE_LIST_FILTERS_SUCCESS:
      return {
        ...state,
        message: messages.SAVE_SUCCESS,
        isPostingFilter: false,
        filters: state.filters.set(action.payload.filter.id, action.payload.filter),
      }
    case POST_EXECUTIVE_LIST_FILTERS_FAILURE:
      return {
        ...state,
        isPostingFilter: false,
        errorMessage: errMessages.ERR_SAVE_FAILURE,
      }
    case PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST:
      return {
        ...state,
        patchingFilterId: action.payload.id,
      }
    case PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS:
      return {
        ...state,
        patchingFilterId: null,
        filters: state.filters.set(action.payload.id, action.payload.filter),
      }
    case PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE:
      return {
        ...state,
        patchingFilterId: null,
        errorMessage: errMessages.ERR_EDIT_FAILURE,
      }
    case DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST:
      return {
        ...state,
        deletingFilterId: action.payload.id,
      }
    case DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS:
      return {
        ...state,
        deletingFilterId: null,
        filters: state.filters.delete(action.payload.id),
      }
    case DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE:
      return {
        ...state,
        deletingFilterId: null,
        errorMessage: errMessages.ERR_REMOVE_FAILURE,
      }
    case SET_SHOW_EXEC_LIST_INFO_BOX:
      return {
        ...state,
        showInfoBox: action.payload.showInfoBox,
      }
    case SET_SHOW_EXEC_LIST_BANNER:
      return {
        ...state,
        showBanner: action.payload.showBanner,
      }
    case CLEAR_EXECUTIVE_LIST:
      return {
        ...initialState,
        showInfoBox: state.showInfoBox,
      }
    case GET_EXPORTED_LIST_REQUEST:
      return {
        ...state,
      }
    case GET_EXPORTED_LIST_SUCCESS:
      list = Map();
      action.payload.list.forEach(item => {
        list = list.set(item.id, item);
      })
      return {
        ...state,
        exportedList: list,
      }
    case GET_EXPORTED_LIST_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error.data.message,
      }
    case POST_EXECUTIVE_LIST_CSV_REQUEST:
      return {
        ...state,
        isLoadingCsv: true,
      }
    case POST_EXECUTIVE_LIST_CSV_SUCCESS:
      return {
        ...state,
        isLoadingCsv: false,
      }
    case POST_EXECUTIVE_LIST_CSV_FAILURE:
      return {
        ...state,
        isLoadingCsv: false,
        errorMessage: action.payload.error.data.message,
      }
    case GET_EXECUTIVE_LIST_UPDATE_REQUEST:
      return {
        ...state,
        isLoadingUpdatedKeyman: true
      }
    case GET_EXECUTIVE_LIST_UPDATE_SUCCESS:
      return {
        ...state,
        isLoadingUpdatedKeyman: false,
        // 更新されたキーマン
        addedKeyman: action.payload.addedKeyman,
        addedKeymanTotalCount: action.payload.addedKeymanTotalCount,
        // 退任されたキーマン
        delKeyman: action.payload.delKeyman,
        delKeymanTotalCount: action.payload.delKeymanTotalCount,
        // 部門電話番号が取得できたキーマン
        existsDepartmentTelKeyman: action.payload.existsDepartmentTelKeyman,
        existsDepartmentTelKeymanTotalCount: action.payload.existsDepartmentTelKeymanTotalCount,
        // おすすめのキーマン
        recommendKeyman: action.payload.recommendKeyman,
        recommendKeymanTotalCount: action.payload.recommendKeymanTotalCount,
      }
    case GET_EXECUTIVE_LIST_UPDATE_FAILURE:
      return {
        ...state,
        isLoadingUpdatedKeyman: false
      }
    case POST_USERS_PAYMENTS_AND_PLANS_SUCCESS:
    case POST_USERS_ME_PLANS_SUCCESS:
      return {
        ...state,
        isSavingPlan: false,
        shortMessage: messages.CHANGE_SUCCESS,
      }
    case POST_EXECUTIVE_LIST_TAGS_GETTAGS_REQUEST:
      if (action.payload.isAllTags) {
        return {
          ...state,
          isLoadingSidebar: state.isLoadingSidebar - 1,
        }
      } else {
        return {
          ...state,
          selectedAddressTags: action.payload.overwrite ? [] : state.selectedAddressTags,
          isLoadingSelectedAddressTags: true,
        }
      }
    case POST_EXECUTIVE_LIST_TAGS_GETTAGS_SUCCESS:
      tags = Array.from(action.payload.tags);
      if (action.payload.isAllTags) {
        return {
          ...state,
          tags: tags,
          isLoadingSidebar: state.isLoadingSidebar + 1,
        }
      } else {
        return {
          ...state,
          selectedAddressTags: tags,
          isLoadingSelectedAddressTags: false,
        }
      }
    case POST_EXECUTIVE_LIST_TAGS_GETTAGS_FAILURE:
      if (action.payload.isAllTags) {
        return {
          ...state,
          errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
          isLoadingSidebar: state.isLoadingSidebar + 1,
        }
      } else {
        return {
          ...state,
          errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
          isLoadingSelectedAddressTags: false,
        }
      }
    case POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_REQUEST:
      return {
        ...state,
        isDeletingTags: true,
      }
    case POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_SUCCESS:
      return {
        ...state,
        isDeletingTags: false,
        shortMessage: messages.DELETE_SUCCESS,
      }
    case POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_FAILURE:
      return {
        ...state,
        isDeletingTags: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_REMOVE_FAILURE),
      }
    case POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_REQUEST:
    case POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_REQUEST:
      return {
        ...state,
        isUpdatingTags: true,
      }
    case POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_SUCCESS:
      return {
        ...state,
        isUpdatingTags: false,
      }
    case POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_FAILURE:
      return {
        ...state,
        isUpdatingTags: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_EDIT_FAILURE)
      }
    case POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_SUCCESS:
      return {
        ...state,
        isUpdatingTags: false,
        tags: Array.from(new Set(state.tags.concat(action.payload.tags))),
        shortMessage: messages.ADD_TAG_SUCCESS,
      }
    case POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_FAILURE:
      return {
        ...state,
        isUpdatingTags: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE)
      }
    case POST_EXECUTIVE_LIST_SALESFORCE_SYNC_REQUEST:
      return {
        ...state,
        isPostingSalesforceSync: true,
      }
    case POST_EXECUTIVE_LIST_SALESFORCE_SYNC_SUCCESS:
      return {
        ...state,
        isPostingSalesforceSync: false,
        message: 'Salesforceに同期中。完了まで数分かかるので、後ほどご確認ください。'
      }
    case POST_EXECUTIVE_LIST_SALESFORCE_SYNC_FAILURE:
      return {
        ...state,
        isPostingSalesforceSync: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_POST_SALESFORCE_SYNC_FAILURE),
      }
    case POST_IP_CHECK_REQUEST:
      return {
        ...state,
        executiveListAdvancedSearchIpCheckLoading: true,
      }
    case POST_IP_CHECK_SUCCESS:
      return {
        ...state,
        executiveListAdvancedSearchIpCheck: action.payload.enabled,
        executiveListAdvancedSearchIpCheckLoading: false,
      }
    case POST_IP_CHECK_FAILURE:
      return {
        ...state,
        executiveListAdvancedSearchIpCheckLoading: false,
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    case CLEAR_ATTACK_LIST_STATE:
      return {
        ...state,
        isLoadingAttackList: false,
        attackListTag: null,
        attackListExtractedConditions: null,
        attackListSummary: null,
        attackListTaggedCount: null,
        attackListError: null,
        // 2段階API
        isAnalyzingUrl: false,
        isExecutingTagging: false,
        attackListAnalysisId: null,
      };
    // 2段階API: Step 1 - URL解析
    case POST_ATTACK_LIST_ANALYZE_URL_REQUEST:
      return {
        ...state,
        isAnalyzingUrl: true,
        attackListError: null,
        attackListExtractedConditions: null,
        attackListSummary: null,
        attackListAnalysisId: null,
      };
    case POST_ATTACK_LIST_ANALYZE_URL_SUCCESS:
      return {
        ...state,
        isAnalyzingUrl: false,
        attackListAnalysisId: action.payload.analysisId,
        attackListExtractedConditions: action.payload.extractedConditions,
        attackListSummary: action.payload.summary,
        attackListError: null,
      };
    case POST_ATTACK_LIST_ANALYZE_URL_FAILURE:
      return {
        ...state,
        isAnalyzingUrl: false,
        attackListError: action.payload.error,
      };
    // 2段階API: Step 2 - タグ付け実行
    case POST_ATTACK_LIST_EXECUTE_TAGGING_REQUEST:
      return {
        ...state,
        isExecutingTagging: true,
        attackListError: null,
      };
    case POST_ATTACK_LIST_EXECUTE_TAGGING_SUCCESS:
      return {
        ...state,
        isExecutingTagging: false,
        attackListTag: action.payload.tag,
        attackListTaggedCount: action.payload.taggedCount,
        attackListError: null,
      };
    case POST_ATTACK_LIST_EXECUTE_TAGGING_FAILURE:
      return {
        ...state,
        isExecutingTagging: false,
        attackListError: action.payload.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/executiveList.js